import React, { useState } from 'react';

interface ActionCellHeaderProps {
  description: string;
}

const ActionCellHeader: React.FC<ActionCellHeaderProps> = ({ description }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  return (
    <div 
      className="absolute top-1 right-1 z-20"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={toggleTooltip}
    >
      <div className="w-4 h-4 text-gray-300 hover:text-gray-500 cursor-help flex items-center justify-center">
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
      </div>
      
      {showTooltip && (
        <div className="absolute top-0 right-0 z-30 bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap max-w-xs">
          {description}
          <div className="absolute top-full right-1 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
};

export default ActionCellHeader;
